import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const FAQ_DATA = [
  {
    question: "Por qué elegir un estudio contable online?",
    answer:
      "Porque permite atención rápida, procesos eficientes, reuniones flexibles y seguimiento profesional sin necesidad de traslados ni envío de papeles.",
  },
  {
    question: "Cómo funciona el servicio contable online?",
    answer:
      "Trabajamos 100% de forma remota. Nos comunicamos por WhatsApp o videollamada. Te envío recordatorios de vencimientos, gestiono tus obligaciones fiscales y estás siempre informado/a del estado de tus trámites.",
  },
  {
    question: "Atendés monotributistas y responsables inscriptos?",
    answer:
      "Sí, asesoro tanto a monotributistas como responsables inscriptos, sean profesionales, comercios, emprendedores o pymes.",
  },
  {
    question: "Realizás altas y bajas en monotributo?",
    answer:
      "Sí, gestiono altas, modificaciones, recategorizaciones y bajas.",
  },
  {
    question: "Trabajás con sociedades?",
    answer:
      "Sí, brindo asesoramiento y gestión contable e impositiva para empresas.",
  },
  {
    question: "Asesorás a importadores y exportadores?",
    answer:
      "Sí, acompaño cuestiones fiscales, administrativas y contables vinculadas al comercio exterior.",
  },
  {
    question: "Tenés clientes exportadores de servicios?",
    answer:
      "Sí, cada vez más personas trabajan para el exterior y necesitan asesoramiento en facturación, cobranzas en moneda extranjera, trámites bancarios y temas vinculados.",
  },
  {
    question: "Cómo es el proceso de trabajo?",
    answer:
      "Primero realizamos una reunión inicial para conocer tu situación. Luego se define la propuesta de trabajo y el presupuesto. Si la propuesta es aceptada, avanzamos con la gestión necesaria y la planificación fiscal.",
  },
  {
    question: "Puedo enviar documentación digital?",
    answer:
      "Sí, trabajamos 100% con documentación digital. Todo se resguarda en la nube.",
  },
  {
    question: "Cómo se cobran los honorarios?",
    answer:
      "Según el servicio, podrá ser abono mensual, trabajo puntual o asesoramiento específico. Escribime por WhatsApp para recibir una cotización personalizada.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      aria-label="Preguntas frecuentes sobre servicios contables online"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto max-w-3xl px-4 md:px-6">
        <div className="mb-12 text-center">
          <span className="mb-3 inline-block font-poppins text-sm font-medium uppercase tracking-wide text-gold">
            FAQ
          </span>
          <h2 className="font-poppins text-3xl font-semibold text-navy-900 md:text-4xl lg:text-5xl">
            Preguntas frecuentes
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQ_DATA.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="overflow-hidden rounded-xl border border-navy-900/5 bg-cream-50 px-6"
            >
              <AccordionTrigger className="py-5 font-poppins text-base font-medium text-navy-900 hover:no-underline md:text-lg">
                <h3 className="text-left">{item.question}</h3>
              </AccordionTrigger>
              <AccordionContent className="pb-5 font-inter text-base leading-relaxed text-navy-700">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
